import { makeSx } from '../../../../theme/_utils'
import { defaultPalette } from '../../../../theme/idsTheme'

export default makeSx({
    patientInsiComparisonErrorContainer: {
        width: '100%',
        minHeight: '60vh',
        color: defaultPalette.error.main,
    },
    patientInsiComparisonErrorInnerContainer: {
        maxWidth: '38rem',
        textAlign: 'center',
    },
    patientInsiComparisonErrorIcon: {
        width: '2rem',
        height: '2rem',
    },
})
